import { type ReactNode } from 'react';
import {
  buildActions,
  type ActionDef,
  type ActionProps,
} from './creator-action-defs';

const ACTION =
  'flex items-center gap-1.5 text-xs text-text-tertiary transition-colors';

function ActionBtn({ a }: { a: ActionDef }): ReactNode {
  if (!a.show || !a.onClick) return null;
  return (
    <button onClick={a.onClick} className={`${ACTION} ${a.hoverCls}`}>
      <a.Icon size={12} />
      {a.label}
    </button>
  );
}

export function CreatorAdminActions(p: ActionProps): ReactNode {
  const actions = buildActions(p);
  return (
    <div className="flex items-center justify-end gap-md pt-sm">
      {actions.map((a) => (
        <ActionBtn key={a.key} a={a} />
      ))}
    </div>
  );
}
